import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-104bf39b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "cd-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "card-icon" }, null, -1))
const _hoisted_4 = { class: "cd-right" }
const _hoisted_5 = { class: "card-content" }
const _hoisted_6 = {
  key: 0,
  class: "it-tools"
}
const _hoisted_7 = { class: "it-container" }
const _hoisted_8 = { class: "it-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "it-left" }, "跟踪建议：", -1))
const _hoisted_10 = { class: "it-right" }
const _hoisted_11 = { class: "dialog-footer" }

import { ref, onMounted, watch, computed } from "vue";
import { getManagerSuggestion } from "@/service/desk-top/custom-detail";
import dayjs from "dayjs";
import { deletePageData, editPageData } from "@/service/main/system";
import { ElMessage } from "element-plus";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonPlanMethodCard',
  props: {
  title: {
    type: String,
    default: ''
  },
  modelValue: {
    type: Array,
    default: []
  },
  wxAccount: {
    type: String,
    default: ''
  },
  userId: {
    type: String,
    default: ''
  },
  empName: {
    type: String,
    default: ''
  },
  groupName: {
    type: String,
    default: ''
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const store = useStore()
const userInfo = store.state.login.userInfo

const props = __props

const emits = __emit

const combinedProps = computed( () => [props.userId, props.wxAccount, props.empName])

watch(() => combinedProps.value, () => {
  getData()
})

const getData = () => {
  const queryInfo = {
    userId: props.userId,
    empName: props.empName,
    wxAccount: props.wxAccount
  }
  getManagerSuggestion(queryInfo).then((res: any) => {
    timelineData.value = res
    emits('update:modelValue', res)
  })
}

const timelineData: any = ref([])

onMounted(() => {
  getData()
})

const dialogVisible = ref(false)
const form: any = ref({})
const handleClick = () => {
  dialogVisible.value = true
  form.value.id = timelineData.value[0].planId
}

const handleEdit = (item: any) => {
  dialogVisible.value = true
  form.value.id = timelineData.value[0].planId
  form.value.recordId = item.id
  form.value.followupSuggestion = item.content
}

const handleSave = () => {
  editPageData('/main/preCommPlan/managerMethods/save', form.value).then(() => {
    ElMessage.success("保存成功")
    dialogVisible.value = false
    getData()
  })
}

const handleDelete = (item: any) => {
  deletePageData('/main/preCommPlan/managerMethods/' + item.id).then(() => {
    ElMessage.success("删除成功")
    getData()
  })
}

const compareDate = (a: any) => {
  // a 格式 '2025-07-15 00:00:02'  判断是否今天 用dayjs
  return dayjs(a).isSame(dayjs(), 'day')
}




return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, null, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("span", null, _toDisplayString(__props.title), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_unref(userInfo).department.name == __props.groupName)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  icon: "el-icon-plus",
                  size: "small",
                  onClick: handleClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (timelineData.value.length > 0)
            ? (_openBlock(), _createBlock(_component_el_timeline, {
                key: 0,
                style: {"max-width":"1200px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelineData.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_timeline_item, {
                      timestamp: item.createdTime + '    ' + item.realName,
                      placement: "top",
                      color: "#105BFC"
                    }, {
                      default: _withCtx(() => [
                        (compareDate(item.createdTime) && _unref(userInfo).realName == item.realName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_el_button, {
                                type: "default",
                                size: "mini",
                                onClick: ($event: any) => (handleEdit(item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("编辑")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_button, {
                                type: "danger",
                                size: "mini",
                                style: {"margin-left":"10px"},
                                onClick: ($event: any) => (handleDelete(item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _createElementVNode("div", _hoisted_10, _toDisplayString(item.content), 1)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["timestamp"]))
                  }), 256))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: "暂无数据"
              }))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      title: "编辑跟踪计划"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSave
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 取消 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          modelValue: form.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form).value = $event)),
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "跟踪建议" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: "4",
                  modelValue: form.value.followupCondition,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.followupCondition) = $event)),
                  placeholder: "请输入内容"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})